// extracted by mini-css-extract-plugin
export default {"wrapper":"P3-z","play":"Q3-z"};